// src/stores/megaMenuStore.ts
import { create } from 'zustand';

// وقتی کاربر روی یه آیتم منو هاور می‌کنه و پنل کشویی باز می‌شه، هدر هم
// باید فوراً به حالت جامد (کرم) بره — دقیقاً مثل ouraring.com که با باز
// شدن منو، کل هدر (نه فقط پنل) به یه رنگ و حالت در میاد.
interface MegaMenuState {
  isOpen: boolean;
  setIsOpen: (open: boolean) => void;
}

export const useMegaMenuStore = create<MegaMenuState>(set => ({
  isOpen: false,
  setIsOpen: open => set({ isOpen: open }),
}));